<h2 mat-dialog-title>Select Management Group</h2>

<mat-dialog-content>
  <mat-form-field>
    <mat-label>Management Group</mat-label>
    <mat-select [(value)]="selectedGroup">
      @for (group of data.managementGroups; track group.id) {
        <mat-option [value]="group">
          {{ group.name }}
        </mat-option>
      }
      @empty {
        <mat-option disabled>No management groups available</mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button
    mat-button
    (click)="onCancel()">
    Cancel
  </button>
  <button
    mat-button
    color="primary"
    [disabled]="!selectedGroup"
    (click)="onSelect()">
    Select
  </button>
</mat-dialog-actions>
